<template>
  <div v-loading="loadingReceivable">
    <zee-receivable-status-bar></zee-receivable-status-bar>
    <div class="x_content">
      <el-tabs type="border-card">
        <el-tab-pane label="Payments">
          <zee-receivable-payments :item="getRTItem.data"></zee-receivable-payments>
        </el-tab-pane>
        <el-tab-pane
          id="comments"
          name="comments">
          <span slot="label">
            Comments
          </span>
          <div class="row">
            <zee-receivable-comments
              :item="getRTItem.data"></zee-receivable-comments>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import zeeReceivableStatusBar from '../receivable-details/partials/ReceivableStatusBar.vue';
import zeeReceivablePayments from '../receivable-details/partials/ReceivablePayments.vue';
import zeeReceivableComments from '../receivable-details/partials/ReceivableComments.vue';

export default {

  components: {
    zeeReceivableStatusBar,
    zeeReceivablePayments,
    zeeReceivableComments,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getRTItem: 'getRTItem',
      loadingReceivable: 'loadingReceivable',
    }),
  },
  beforeMount() {
    document.querySelector('body').className = 'is-receivable';
  },
  created() {
    this.$store.dispatch('setRTItem', { id: this.id });
  },
};


</script>

<style lang="scss" scoped>


</style>



// WEBPACK FOOTER //
// src/components/receivables/receivable/receivable-details/ReceivableDetails.vue